import { getWellbeingTexture, geMindsetTexture, getLearningTexture, getResilienceTexture } from './TextureHelper'

export const InitLearning = (value) => {
    let texture = getLearningTexture(value.percentage)
    let LevelString = getLevelString(value.percentage);
    let levelpercent = getLevelPercent(value.percentage);

    let myObj = {
        "id": value.traitGroupId, "name": value.traitGroupName, "recommendedAmount": value.recommendationCount - value.completedRecCount,
        "texture": texture, "traitGroupScore": value.percentage, "levelString": LevelString,
        "levelPercent": levelpercent,
    }
    return myObj;
}
export const InitMindset = (value) => {
    let texture = geMindsetTexture(value.percentage)
    let LevelString = getLevelString(value.percentage);
    let levelpercent = getLevelPercent(value.percentage);

    let myObj = {
        "id": value.traitGroupId, "name": value.traitGroupName, "recommendedAmount": value.recommendationCount - value.completedRecCount,
        "texture": texture, "traitGroupScore": value.percentage, "levelString": LevelString,
        "levelPercent": levelpercent,
    }

    return myObj;
}
export const InitWellbeing = (value) => {
    let texture = getWellbeingTexture(value.percentage)
    let LevelString = getLevelString(value.percentage);
    let levelpercent = getLevelPercent(value.percentage);

    let myObj = {
        "id": value.traitGroupId, "name": value.traitGroupName, "recommendedAmount": value.recommendationCount - value.completedRecCount,
        "texture": texture, "traitGroupScore": value.percentage, "levelString": LevelString,
        "levelPercent": levelpercent,
    }
    return myObj;
}
export const InitResilience = (value) => {
    let texture = getResilienceTexture(value.percentage)
    let LevelString = getLevelString(value.percentage);
    let levelpercent = getLevelPercent(value.percentage);

    let myObj = {
        "id": value.traitGroupId, "name": value.traitGroupName, "recommendedAmount": value.recommendationCount - value.completedRecCount,
        "texture": texture, "traitGroupScore": value.percentage, "levelString": LevelString,
        "levelPercent": levelpercent,
    }
    return myObj;
}

export const getLevelString = (score) => {
    const totalScore = score === null ? 0 : score;
    const currentLevel = Math.floor(totalScore / 20);
    if (totalScore > 100) {
        return "EXTRA MAX";
    }
    else if (currentLevel >= 5) {
        return "MAX";
    }
    else {
        return currentLevel + " / 5";
    }
}
export const getLevelPercent = (score) => {
    const totalScore = score === null ? 0 : score;
    if (totalScore > 100)
        return 100;
    else
        return totalScore;
}